import styled from 'styled-components'

export const Container = styled.div`
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f8fafc;
  font-family: 'Roboto', sans-serif;
  padding: 24px;
`

export const Card = styled.div`
  width: 900px;
  max-width: 95%;
  display: flex;
  gap: 24px;
  background-color: #ffffff;
  border-radius: 8px;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.08);
  overflow: hidden;
`

export const Left = styled.div`
  background-color: #25262c;
  color: #ffffff;
  width: 40%;
  min-width: 260px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 28px;
`

export const Img = styled.img`
  width: 160px;
  height: auto;
  margin-bottom: 20px;
`

export const Title = styled.h1`
  font-size: 20px;
  margin-bottom: 8px;
  color: #f8fafc;
`

export const Subtitle = styled.p`
  margin: 0;
  font-size: 14px;
  color: #cbd5e1;
`

export const Right = styled.div`
  padding: 22px;
  flex: 1;
  background-color: #f1f5f9;
  display: flex;
  flex-direction: column;
  gap: 12px;
`

export const ToolbarUL = styled.ul`
  display: flex;
  gap: 12px;
  list-style: none;
  padding: 0;
  margin: 0;
`

export const ToolItem = styled.li``

export const ToolButton = styled.button`
  background: transparent;
  border: none;
  padding: 8px 10px;
  cursor: pointer;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;

  /* Icon/button foreground color */
  color: ${({active}) => (active ? '#faff00' : '#f1f5f9')};
`

export const StyledTextArea = styled.textarea`
  min-height: 280px;
  resize: vertical;
  border-radius: 6px;
  border: 1px solid #cbd5e1;
  padding: 12px;
  font-size: 16px;
  outline: none;
  background: white;
`
